export default __webpack_public_path__ + "static/media/PS5-DE-2.0c2f963b.jpg";